import React from 'react';
import PropTypes from 'prop-types';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

import GridContainer from '../../../components/Grid/GridContainer.jsx';
import GridItem from '../../../components/Grid/GridItem.jsx';
import Card from '../../../components/Card/Card.jsx';
import CardBody from '../../../components/Card/CardBody.jsx';

import CardHeader from '../../../components/Card/CardHeader';
import CardIcon from '../../../components/Card/CardIcon';
import PermIdentity from '@material-ui/icons/PermIdentity';

import Button from '../../../components/CustomButtons/Button';

import {cardTitle} from '../../../assets/jss/material-dashboard-pro-react.jsx';

import EntitybanksNewContainer from '../../../components/Entitybanks/EntitybanksNewContainer';
import EntitybanksTableContainer from '../../../components/Entitybanks/EntitybanksTableContainer';
import EntitybanksEditContainer from '../../../components/Entitybanks/EntitybanksEditContainer';

const entitiesStyles = {
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    '& small': {
      fontSize: '80%',
      fontWeight: '400'
    }
  },
  cardCategory: {
    marginTop: '10px',
    color: '#999999 !important',
    textAlign: 'center'
  },
  description: {
    color: '#999999'
  },
  updateProfileButton: {
    float: 'right'
  },
  title: {
    color: '#3C4858',
    textDecoration: 'none'
  },

  flexEnd: {
    display: 'flex',
    justifyContent: 'space-between'
  }
};

/**
 * ----------------------------------------------------------------------------
 * CLASS - COUNTRIES
 * ----------------------------------------------------------------------------
 */
class Entitybanks extends React.Component {
  selectUi() {
    console.log(this.props.entity_banks.entitybanks_current_ui);
    switch (this.props.entity_banks.entitybanks_current_ui) {
      case 'create':
        return <EntitybanksNewContainer />;
      case 'edit':
        console.log(this.props.entity_banks);
        return <EntitybanksEditContainer eb_id={this.props.entity_banks.id} />;
      default:
        return <EntitybanksTableContainer />;
    }
  }

  render() {
    const {classes} = this.props;
    console.log(this.props);
    return (
      <div>
        <Card>
          <CardHeader color='rose' icon>
            <CardIcon color='rose'>
              <PermIdentity />
            </CardIcon>
            <div className={classes.flexEnd}>
              <h4 className={classes.cardIconTitle}>Bank Accounts</h4>
              <div>
                <Button
                  round
                  color={this.props.entity_banks.entitybanks_current_ui === 'list' ? 'rose' : null}
                  onClick={() => this.props.selectEntitybanksUi('list')}
                >
                  Show All
                </Button>
                <Button
                  round
                  color={this.props.entity_banks.entitybanks_current_ui === 'create' ? 'rose' : null}
                  onClick={() => this.props.selectEntitybanksUi('create')}
                >
                  Create New
                </Button>
                {this.props.entity_banks.entitybanks_current_ui === 'edit' && (
                  <Button
                    round
                    color={this.props.entity_banks.entitybanks_current_ui === 'edit' ? 'rose' : null}
                    onClick={() => this.props.selectEntitybanksUi('edit')}
                  >
                    Edit Record
                  </Button>
                )}
                {this.props.entity_banks.entitybanks_current_ui !== 'edit' &&
                  this.props.entity_banks.entitybanks_current_ui !== 'create' && (
                    <Button
                      round
                      // onClick={() => this.props.selectEntitybanksUi("list")}
                      onClick={() => this.props.fetchEntitybanksListNotDeleted()}
                    >
                      Refresh
                    </Button>
                  )}
              </div>
            </div>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12}>{this.selectUi()}</GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </div>
    );
  }
}

Entitybanks.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(entitiesStyles)(Entitybanks);
